interface IRecovery {
    debtIdentifier: string;
    licensePlate: string;
}

export const toRecoveryKey = (recovery: IRecovery) =>
    `${recovery.debtIdentifier}-${recovery.licensePlate}`;
